<div class="modal-header">
    <h4 class="modal-title pull-left" translate>{{title}} task status</h4>
</div>
<div class="modal-body ng-workflow-add-block cs-timeline">
    <div class="task-container diagram-container">
        <div class="task-item">
            <div class="task-header">{{startDate.format('dddd, Do MMMM YYYY')}}</div>
            <div class="task-content">
                <div>Started on {{startDate.format('dddd MMMM YYYY')}} ({{startDate.format('HH:mm:ss')}})</div>
                <div class="short-content">
                    <div class="d-block">
                        <div class="inline-block"><b>Status</b></div>
                        <div class="inline-block ml-05 ">Running <span class="color-box color-box-sm color-box-status-running rounded"></span></div>
                    </div>
                </div>
            </div>
            <div *ngIf="isTaskOnSameDate" class="item-tail"></div>
        </div>

        <div class="task-item" *ngIf="showSkippedStatus">
            <div class="task-header" *ngIf="!isTaskOnSameDate">{{endDate.format('dddd, Do MMMM YYYY')}}</div>
            <div class="task-content">
                <div>Skipped on {{endDate.format('dddd MMMM YYYY')}} ({{endDate.format('HH:mm:ss')}})</div>
                <div class="short-content">
                    <div class="d-block">
                        <div class="inline-block"><b>Status</b></div>
                        <div class="inline-block ml-05 ">Skipped <span class="color-box color-box-sm color-box-status-skipped rounded"></span></div>
                    </div>
                    <div class="d-block" *ngIf="task?.taskParams && task.taskParams['message']">
                        <div class="inline-block"><b>Message</b></div>
                        <div class="inline-block ml-05 ">{{task.taskParams['message']}} </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-item" *ngIf="showFailedStatus">
            <div class="task-header" *ngIf="!isTaskOnSameDate">{{endDate.format('dddd, Do MMMM YYYY')}}</div>
            <div class="task-content">
                <div>Failed on {{endDate.format('dddd MMMM YYYY')}} ({{endDate.format('HH:mm:ss')}})</div>
                <div class="short-content mb-10">
                    <div class="d-block">
                        <div class="inline-block"><b>Status</b></div>
                        <div class="inline-block ml-05 ">Failed <span class="color-box color-box-sm color-box-status-failed rounded"></span></div>
                    </div>
                    <div class="d-block" *ngIf="task?.taskParams && task.taskParams['message']">
                        <div class="inline-block"><b>Message</b></div>
                        <div class="inline-block ml-05 ">{{task.taskParams['message']}} </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-item" *ngIf="showSuccessStatus">
            <div class="task-header" *ngIf="!isTaskOnSameDate">{{endDate.format('dddd, Do MMMM YYYY')}}</div>
            <div class="task-content">
                <div>Completed on {{endDate.format('dddd MMMM YYYY')}} ({{endDate.format('HH:mm:ss')}})</div>
                <div class="short-content mb-10">
                    <div class="d-block">
                        <div class="inline-block"><b>Status</b></div>
                        <div class="inline-block ml-05 ">Success <span class="color-box color-box-sm color-box-status-completed rounded"></span></div>
                    </div>
                </div>
                <div class="truncate-content"  *ngIf="showFullDetails">
                    <a class="cursor-pointer" (click)='viewFullDetails(communicationId)'>View full details</a>
                </div>
                <div class="block-email-section" *ngIf="showContent=='email'">
                    <div class="short-content">
                        <div class="d-block">
                            <div class="inline-block">Email sent from: </div>
                            <div class="inline-block ml-05 "><b>{{emailMessageData['fromEmail']}}</b></div>
                        </div>
                    </div>
                    <div class="short-content mb-10">
                        <div class="d-block">
                            <div class="inline-block"><b>To: </b></div>
                            <div class="inline-block ml-05 ">{{emailMessageData['toEmail']}}</div>
                        </div>
                        <div class="d-block" *ngIf="emailMessageData['ccEmail']">
                            <div class="inline-block"><b>CC: </b></div>
                            <div class="inline-block ml-05 ">{{emailMessageData['ccEmail']}}</div>
                        </div>
                        <div class="d-block" *ngIf="emailMessageData['bccEmail']">
                            <div class="inline-block"><b>BCC: </b></div>
                            <div class="inline-block ml-05 ">{{emailMessageData['bccEmail']}}</div>
                        </div>
                    </div>
                    <div class="short-content mb-10">
                        <div class="d-block">
                            <div class="inline-block"><b>Subject: </b></div>
                            <div class="inline-block ml-05 " [innerHTML]="emailMessageData['subject']"></div>
                        </div>
                    </div>
                    <div class="short-content mb-10">
                        <div class="d-block">
                            <div class="inline-block" [innerHTML]="emailMessageData['message'] | keepHtml"></div>
                        </div>
                    </div>
                    <div class="short-content">
                        <div class="d-block">
                            <div class="inline-block"><b>Email status: </b></div>
                            <div class="inline-block ml-05 ">{{emailMessageData['status']}}</div>
                        </div>
                    </div>
                    <div class="short-content">
                        <div class="d-block">
                            <div class="inline-block"><b>Email sentby: </b></div>
                            <div class="inline-block ml-05 ">{{emailMessageData['sentBy']}}</div>
                        </div>
                    </div>
                    <div class="truncate-content"  *ngIf="showLessDetails">
                        <a class="cursor-pointer" (click)='viewLessDetails()'>Show less</a>
                    </div>
                </div>

                <div class="block-sms-section" *ngIf="showContent=='sms'">
                    <div *ngFor="let recipient of smsMessageData['recipients']">
                        <div class="short-content mb-10" >
                            <div class="d-block">
                                <div class="inline-block"><b>To: </b></div>
                                <div class="inline-block ml-05 ">{{recipient.mobileNumber}}</div>
                            </div>
                            <div class="d-block">
                                <div class="inline-block"><b>Status: </b></div>
                                <div class="inline-block ml-05 ">{{recipient.status}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="short-content mb-10">
                        <div class="d-block">
                            <div class="inline-block" [innerHTML]="smsMessageData['message'] | keepHtml"></div>
                        </div>
                    </div>
                    <div class="truncate-content"  *ngIf="showLessDetails">
                        <a class="cursor-pointer" (click)='viewLessDetails()'>Show less</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <a href="javascript:void(0)" class="btn" (click)="modalRef.hide()">Close</a>
</div>

